module.exports = __webpack_public_path__ + "static/intercom-integration1-8e598642626912dc8220f698aa05718d.png";